import "./Expertise.module.css";
import Navigation from "@/reusable_sections/Header";
import Capabilities from "./sections/Capabilities";
import Compliance from "./sections/Compliance";
import Footer from "@/reusable_sections/Footer";
export default function ExpertisePage() {
  return <div>
      <Navigation />
      <Capabilities />
      <Compliance />
      <Footer />
    </div>;
}